document.addEventListener('DOMContentLoaded', () => {
	const isAdultsOnly = window.isAdultsOnly;
	const popup = document.getElementById('adults-popup');
	popup?.querySelector('.modal__overlay')?.addEventListener('click', (e) => {
		e.stopPropagation();
		e.preventDefault();
	});
	if (!isAdultsOnly) {
		return;
	}
	const isUnder18 = sessionStorage.getItem('isUnder18') === 'true';
	const isOver18 = sessionStorage.getItem('isOver18') === 'true';

	if (isUnder18) {
		const addToCartBtn = document.querySelector('button#AddToCart');

		if (addToCartBtn) {
			addToCartBtn.disabled = true;
			addToCartBtn.style.pointerEvents = 'none';
			addToCartBtn.style.opacity = '0.5';
		}
		if (addToCartBtn) {
			addToCartBtn.addEventListener('click', (e) => {
				e.preventDefault();
			});
		}
		document
			.querySelectorAll('form.product-item__quick-form button[type="submit"]')
			.forEach((button) => {
				button.disabled = true;
				button.style.pointerEvents = 'none';
				button.style.opacity = '0.5';
			});
		document.querySelectorAll('form.product-item__quick-form').forEach((form) => {
			form.addEventListener(
				'submit',
				(e) => {
					const isUnder18 = sessionStorage.getItem('isUnder18') === 'true';
					if (isUnder18) {
						e.preventDefault();
						e.stopImmediatePropagation();
						return false;
					}
				},
				{ capture: true }
			);
		});
	}

	if (!sessionStorage.getItem('showedAdultsPopup')) {
		if (popup) {
			popup.open = true;
		}
	}

	const showPopupIfNeeded = (event) => {
		if (!sessionStorage.getItem('showedAdultsPopup')) {
			event.preventDefault();
			event.stopPropagation();
			popup.open = true;
		}
	};

	const addToCartBtn = document.querySelector('button#AddToCart');
	if (addToCartBtn) {
		addToCartBtn.addEventListener('click', showPopupIfNeeded);
	}
	const quickBuyForms = document.querySelectorAll('form.product-item__quick-form');
	quickBuyForms.forEach((form) => {
		form.addEventListener('submit', (event) => {
			if (!sessionStorage.getItem('showedAdultsPopup')) {
				event.preventDefault();
				event.stopPropagation();
				popup.open = true;
				form.dataset.pendingSubmit = 'true';
			}
		});
	});
});
const popup = document.getElementById('adults-popup');

const over18Btn = popup?.querySelector('[data-over-18]');
const under18Btn = popup?.querySelector('[data-under-18]');

over18Btn?.addEventListener('click', () => {
	sessionStorage.setItem('isOver18', 'true');
	sessionStorage.setItem('isUnder18', 'false');
	sessionStorage.setItem('showedAdultsPopup', 'true');
	popup.open = false;
	const pendingForm = document.querySelector('form[data-pending-submit="true"]');
	if (pendingForm) {
		pendingForm.removeAttribute('data-pending-submit');
		pendingForm.submit();
	}
});
under18Btn?.addEventListener('click', () => {
	sessionStorage.setItem('isUnder18', 'true');
	popup.open = false;
	if (window.location.pathname.includes('/products/')) {
		window.location.href = window.themeVariables?.routes?.rootUrl || '/';
	}
});
